import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { theme } from '../theme';
import { useIsMobile } from '../hooks/useMediaQuery';

const inputStyle = {
  width: '100%',
  padding: '10px 14px',
  backgroundColor: theme.colors.background,
  border: `1px solid ${theme.colors.border}`,
  borderRadius: '7px',
  color: theme.colors.text,
  fontSize: '1rem',
  boxSizing: 'border-box',
  outline: 'none',
};

const labelStyle = {
  display: 'block',
  color: theme.colors.textMuted,
  marginBottom: '0.4rem',
  fontSize: '0.9rem',
};

function ResetPassword() {
  const isMobile = useIsMobile();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!token) {
    return (
      <main style={{ padding: isMobile ? '2rem 1rem' : '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
        <div style={{
          backgroundColor: theme.colors.surface,
          borderRadius: '14px',
          border: `1px solid ${theme.colors.border}`,
          padding: isMobile ? '1.75rem 1.25rem' : '2.5rem',
          width: '100%',
          maxWidth: '420px',
          textAlign: 'center',
          boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
        }}>
          <p style={{ color: theme.colors.error, marginBottom: '1.5rem', fontSize: '0.95rem' }}>
            Enlace inválido o incompleto.
          </p>
          <Link to="/forgot-password" style={{ color: theme.colors.primary, textDecoration: 'none', fontSize: '0.9rem' }}>
            Solicitar nuevo enlace
          </Link>
        </div>
      </main>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden');
      return;
    }
    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setError(data.message || 'Error al restablecer la contraseña');
        return;
      }
      navigate('/login', { state: { resetSuccess: true } });
    } catch {
      setError('Error de conexión. Verifica que el servidor esté corriendo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main style={{ padding: '3rem 1.5rem', display: 'flex', justifyContent: 'center' }}>
      <div style={{
        backgroundColor: theme.colors.surface,
        borderRadius: '14px',
        border: `1px solid ${theme.colors.border}`,
        padding: '2.5rem',
        width: '100%',
        maxWidth: '420px',
        boxShadow: `0 4px 24px ${theme.colors.glowSubtle}`,
      }}>
        <h1 style={{ color: theme.colors.primary, marginBottom: '0.5rem', textAlign: 'center', fontSize: '1.5rem' }}>
          Nueva contraseña
        </h1>
        <p style={{ color: theme.colors.textMuted, textAlign: 'center', fontSize: '0.9rem', marginBottom: '2rem' }}>
          Elige una contraseña segura para tu cuenta.
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.2rem' }}>
            <label style={labelStyle}>Nueva contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              autoComplete="new-password"
              style={inputStyle}
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={labelStyle}>Confirmar contraseña</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              autoComplete="new-password"
              style={inputStyle}
            />
          </div>

          {error && (
            <p style={{ color: theme.colors.error, textAlign: 'center', marginBottom: '1rem', fontSize: '0.9rem' }}>
              {error}
            </p>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: loading ? theme.colors.border : theme.colors.primary,
              color: theme.colors.background,
              border: 'none',
              borderRadius: '7px',
              fontSize: '1rem',
              fontWeight: '700',
              cursor: loading ? 'not-allowed' : 'pointer',
              marginBottom: '1rem',
            }}
          >
            {loading ? 'Guardando...' : 'Cambiar contraseña'}
          </button>

          <p style={{ textAlign: 'center', margin: 0 }}>
            <Link to="/forgot-password" style={{ color: theme.colors.textMuted, fontSize: '0.85rem', textDecoration: 'none' }}>
              Solicitar nuevo enlace
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}

export default ResetPassword;
